module.exports = __webpack_public_path__ + "static/media/Montserrat-Regular.f7213526.ttf";